import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components';

import { Colors } from '../../styles/vars';
import { hashString, initials } from '../../utils/misc';

const AvatarWrapper = styled.div`
  position: relative;
  height: ${props => props.$size}px;
  aspect-ratio: 1;

  border-radius: 50%;
  box-shadow: 0 0 0 1.5px ${Colors.white};

  overflow: hidden;

  @media print {
    display: none !important;
  }

  img,
  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    object-fit: cover;
    object-position: center;

    pointer-events: none;
  }
`;

const AvatarFallback = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  color: ${Colors.pureWhite};
  background-color: ${Colors.accent};
  text-align: center;
  font-size: 12px;
  font-weight: 900;
`;

const UserAvatar = memo(({ name, email, size }) => {
  const [hash, setHash] = useState(null);

  useEffect(() => {
    if (email) {
      let isMounted = true;

      (async () => {
        const newHash = await hashString(email.trim().toLocaleLowerCase());

        if (newHash && newHash !== hash && isMounted) {
          setHash(newHash);
        }
      })();

      return () => {
        isMounted = false;
      };
    }
  }, [email]);

  return (
    <AvatarWrapper $size={size}>
      {hash && (
        <img
          src={encodeURI(
            `https://gravatar.com/avatar/${hash}?r=g&d=blank&name=${name}`,
          )}
          alt={name}
        />
      )}

      <AvatarFallback>{initials(name)}</AvatarFallback>
    </AvatarWrapper>
  );
});

UserAvatar.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  size: PropTypes.number,
};

UserAvatar.defaultProps = {
  name: '',
  email: '',
  size: 24,
};

export default UserAvatar;
